import { Component, OnInit } from '@angular/core';
import { KGridHelper } from '../../../../_helpers/k-grid.class';
import { Subject, Subscription } from 'rxjs';
import { PaymentInstallmentViewModel } from '../../payments-model';
import { PaymentsService } from '../../payments.service';
import { NotificationService } from '../../../../_services/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from '../../../clients/clients.service';
import { LocalService } from '../../../../_services/local.service';
import { ExportExcelService } from '../../../../_services/export-excel.service';
import { orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { PageChangeEvent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-due-offset-detail',
  templateUrl: './due-offset-detail.component.html',
  styleUrls: ['./due-offset-detail.component.scss']
})
export class DueOffsetDetailComponent implements OnInit {

   public kGrid: KGridHelper = new KGridHelper();
    public searchEvent = new Subject<any>();
    public searchSubcription: Subscription = null;
    public saving = false;
    public deleting = false;
    public createOrUpdateDialog = false;
    public deleteConfirmationDialog = false;
    public itemList = [];
    public originalItemList = [];
    public vm: PaymentInstallmentViewModel = new PaymentInstallmentViewModel();
    public searchTerm: string = "";
    public addNewUrl: string = "/payments/payment-installments/";
    public addDetailUrl: string = "/payments/payment-detail/";
    public RecordId: number;
    constructor(
      public _paymentsService: PaymentsService,
      public _notificationService: NotificationService,
      private activatedRoute: ActivatedRoute,
      public _clientService: ClientService,
      private router: Router,
      public _localService: LocalService,
      private _exportToExcelService: ExportExcelService
    ) {
      this.activatedRoute.queryParams.subscribe(params => {
        this.RecordId = params['id'];
      });
    }
  
    ngOnInit() {
      this.initializeProps();
      this.getOffsetDetailRecordByDuePayment();
    }
    private initializeProps() {
      this.kGrid.loading = false;
      this.kGrid.pageSize = 20;
      this.kGrid.pageSizes = [20, 50, 100];
    }
  
    public getOffsetDetailRecordByDuePayment() {
      this._paymentsService.getOffsetDetailRecordByDuePayment(this.kGrid.skip, this.kGrid.pageSize, this.kGrid.searchQuery, this.kGrid.hfId, this.kGrid.geoLvlCode, this.kGrid.hfType, this.kGrid.stockId, this.searchTerm, this.RecordId).subscribe((res: any) => {
        debugger;
        if (res) {
          console.log(res);

          let data = res.DtlList;

      // 👇 Add running balance logic here
      let totalPaid = 0;
      for (let row of data) {
        totalPaid += row.PaidAmount || 0;
        row.RunningBalance = (row.TotalAmount || 0) - totalPaid;
      }
      
          this.kGrid.data = [];
          this.kGrid.data = res.DtlList;
          this.kGrid.totalRecords = res.TotalCount;
          this.kGrid.gridView = { data: this.kGrid.data, total: this.kGrid.totalRecords };
          this.kGrid.loading = false;
        }
      }, err => {
        debugger;
  
        this._notificationService.notify("danger", err.msg);
  
      });
    }
    getBySearchTerm(e) {
      if (this.searchTerm !== ' ') {
        this._paymentsService.getOffsetDetailRecordByDuePayment(this.kGrid.skip, this.kGrid.pageSize, this.kGrid.searchQuery, this.kGrid.hfId, this.kGrid.geoLvlCode, this.kGrid.hfType, this.kGrid.stockId, this.searchTerm, this.RecordId).subscribe((res: any) => {
          if (res) {
            console.log(res);
            this.kGrid.data = [];
            this.kGrid.data = res.DtlList;
            this.kGrid.totalRecords = res.TotalCount;
            this.kGrid.gridView = { data: this.kGrid.data, total: this.kGrid.totalRecords };
            this.kGrid.loading = false;
          }
        }, (error) => {
          console.log(error);
        });
      } else {
        this.ngOnInit();
      }
    }
  
    isExcelExport: boolean = false;
    exportToExcel() {
      this.isExcelExport = true;
      let excelArr = [];
  
      for (let i = 0; i < this.kGrid.data.length; i++) {
        let obj = {
          InvoiceNumber: this.kGrid.data[i].InvoiceNumber,
          Account: this.kGrid.data[i].FK_Account.Name,
          Type: this.kGrid.data[i].Type,
          Source: this.kGrid.data[i].Source,
          TotalAmount: this.kGrid.data[i].TotalAmount,
          PaidAmount: this.kGrid.data[i].PaidAmount,
          RemainingAmount: this.kGrid.data[i].RemainingAmount,
        }
        excelArr.push(obj);
      }
      this.isExcelExport = false;
      this._exportToExcelService.exportAsExcelFile(excelArr, 'DuePayments');
      console.log('new array', excelArr);
    }
  
    public changePagesize(value: any) {
      this.kGrid.pageSize = +value;
      this.kGrid.skip = 0;
      this.getOffsetDetailRecordByDuePayment();
    }
    public sortChange(sort: SortDescriptor[]): void {
      if (sort[0].field == 'asd') { return; }
      this.kGrid.sort = sort;
      this.sortData();
    }
    private sortData() {
      this.kGrid.gridView = {
        data: orderBy(this.kGrid.data, this.kGrid.sort),
        total: this.kGrid.totalRecords
      };
    }
    public pageChange(event: PageChangeEvent): void {
      this.kGrid.skip = event.skip;
      this.getOffsetDetailRecordByDuePayment();
    }

}
